<ng-template #modal>
  <div class="popup-window">
    <div class="modal-header">
      <h5 tabindex="0" id="confirm-title" class="modal-title">{{ modalConfig.modalTitle }}</h5>
    </div>
    <div tabindex="0" class="modal-body">
      <ng-content></ng-content>
    </div>
    <div class="modal-footer">
      @if (modalConfig.hideCloseButton === undefined || !modalConfig.hideCloseButton()) {
        <button type="button" class="btn primary rounded-pill submit" (click)="confirm()"
                [disabled]="modalConfig.disableCloseButton !== undefined && modalConfig.disableCloseButton()">
          {{ modalConfig.confirmButtonLabel }}
        </button>
      }
      @if (modalConfig.hideDismissButton === undefined || !modalConfig.hideDismissButton()) {
        <button type="button" class="btn secondary rounded-pill cancel pull-right" (click)="dismiss()"
                [disabled]="modalConfig.disableDismissButton !== undefined && modalConfig.disableDismissButton()">
          {{ modalConfig.dismissButtonLabel }}
        </button>
      }
    </div>
  </div>
</ng-template>
